import { useRef } from 'react';

import useImagesEffect, { Effect } from 'app/components/Viewer/useImagesEffect';
import { ViewerImage } from 'app/components/Viewer/types';

type UseImagesEffectProps = { effect: Effect; images?: ViewerImage[]; deps?: any[] };

export default function UseImagesEffect({
  effect,
  images = undefined,
  deps = undefined,
}: UseImagesEffectProps): null {
  const imagesRef = useRef<ViewerImage[] | undefined>();
  useImagesEffect((...args) => effect(...args), images, imagesRef.current, deps);
  imagesRef.current = images;

  return null;
}
